export const urgencyLevels = [
  { label: 'Urgent', value: 5 },
  { label: 'High', value: 4 },
  { label: 'Medium', value: 3 },
  { label: 'Low', value: 2 },
  { label: 'Parked', value: 1 },
];
